<template>
    <div class="report" v-if="loaded">
        <h1>Cashflow Report</h1>
        <div class="report-options">
            <div class="row">
                <div class="col-md-5">
                    <label>From Date</label>
                    <datepicker v-model="fromDate" id="fromDate" name="fromDate" :input-class="['form-control']" :use-utc="true"></datepicker>
                </div>
                <div class="col-md-5">
                    <label>To Date</label>
                    <datepicker v-model="toDate" id="fromDate" name="fromDate" :input-class="['form-control']" :use-utc="true"></datepicker>
                </div>
                <div class="col-md-2">
                    <label>&nbsp;</label>
                    <button class="btn orcaBtn sm-btn" @click="reloadReportData()">Refresh</button>
                </div>
            </div>
        </div>

        <div class="report-visualisation" style="max-width: 100%;">
            <apexchart height="600" type="line" :options="options" :series="series"></apexchart>
        </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import VueApexCharts from 'vue-apexcharts'
import Vue from 'vue';

Vue.use(VueApexCharts)

export default {
    name: "Profit_and_loss",
    components: {
        apexchart: VueApexCharts,
        datepicker: Datepicker,
    },
    data() {
        return {
            loaded: false,

            options: null,
            series: null,

            fromDate: null,
            toDate: null,

            // Flags
            isPayroll: false,
            isRecruitment: false,
            isPayrollEnabled: false,
            isRecruitmentEnabled: false
        }
    },
    created() {
        this.fromDate = new Date();
        this.toDate = new Date();

        this.setFlags();
        this.reloadReportData();
    },
    methods: {
        setFlags() {
            this.isPayroll = (this.crmType === 'payroll')
            this.isRecruitment = (this.crmType === 'recruitment');
            this.isPayrollEnabled = (this.isPayroll || this.isRecruitment && !this.$store.state.auth.me.recruitment);
            this.isRecruitmentEnabled = (this.isRecruitment && this.$store.state.auth.me.recruitment)
        },
        reloadReportData() {
            this.series = [
                {
                    name: 'Series A',
                    data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
                },
                {
                    name: 'Series B',
                    data: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16]
                },
                {
                    name: 'Series C',
                    data: [10, 5, 12, 4, 15, 17, 18, 19, 20, 21 ]
                }
            ];

            this.options = {
                chart: {
                    height: 600,
                    type: 'line',
                    toolbar: {
                        show: false
                    }
                },
                colors: ['#390d58', '#b51253', '#61b512'],
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth'
                },
                yaxis: {
                    labels: {
                        formatter: function (value) {
                            let currency = (new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }));

                            return currency.format(value);
                        }
                    },
                },
            };

            this.loaded = true; // TODO Change to be based on laod of report data
        },
    }
}
</script>
